import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import { useGetStatisticsOnHold } from '@nxsys/hooks/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { useEffect, useMemo, useState } from 'react';
import OnHoldModal, { OnHoldModalTypeEnum } from './components/OnHoldModal';

const OnHold = () => {
  const { messages } = useTypedIntl();
  const { value, loading, run } = useGetStatisticsOnHold();
  const data = useMemo(() => value?.data, [value]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState<OnHoldModalTypeEnum | null>(null);

  useEffect(() => {
    run();
  }, []);

  const handleOpenModal = (type: OnHoldModalTypeEnum) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  const items = [
    {
      title: data?.totalPendingInvoice,
      description: 'Pending INV Generation',
      onClick: () =>
        handleOpenModal(OnHoldModalTypeEnum.PENDING_INV_GENERATION),
    },
    {
      title: data?.totalPendingPayment,
      description: messages['common.pendingEmployeePayments'],
      onClick: () => handleOpenModal(OnHoldModalTypeEnum.PENDING_PAYMENTS),
    },
  ];

  return (
    <div className="OnHold h-full">
      <AppCard className="p-[24px] h-full" loading={loading}>
        <div className="flex justify-between items-center mb-[24px]">
          <AppIconCard
            iconName="IconClipboardMinus"
            title="On Hold (With Timesheets)"
          />
        </div>
        <div className="space-y-[16px]">
          {items.map((item) => (
            <div
              key={item.title}
              className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px] flex items-center w-full gap-x-[12px]"
              onClick={item.onClick}
            >
              <div className="border-[3px] border-neutral-500 rounded-full w-[12px] h-[12px]"></div>
              <div className="flex gap-x-[8px] flex-1 items-center">
                <div className="text-[22px] font-bold">{item.title}</div>
                <div className="text-[14px] font-bold">{item.description}</div>
              </div>
              <Icons.IconArrowRight />
            </div>
          ))}
        </div>
      </AppCard>
      {modalType && (
        <OnHoldModal
          isOpen={isOpenModal}
          toggle={() => setIsOpenModal(false)}
          type={modalType}
        />
      )}
    </div>
  );
};

export default OnHold;
